<div class="container-fluid">
  <div class="container p-4">

    <div class="row mb-4">
      <div class="col-12">
        @if (therapistId){
        <h2>UPDATE THERAPIST DETAILS</h2>
        } @else {
        <h2>CREATE NEW THERAPIST</h2>
        }
      </div>
    </div>


    <form [formGroup]="therapistForm" class="therapist__form">
      <div class="row">
        <div class="col-12 mb-3">
          <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
            <mat-label>FIRST NAME</mat-label>
            <input type="text" matInput formControlName="firstName" placeholder="John">
            @if (therapistForm.get('firstName')?.hasError('required')) {
            <mat-error>First name is <strong>required</strong></mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-12 mb-3">
          <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
            <mat-label>LAST NAME</mat-label>
            <input type="text" matInput formControlName="lastName" placeholder="Smith">
            @if (therapistForm.get('firstName')?.hasError('required')) {
            <mat-error>Last name is <strong>required</strong></mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-12 mb-3">
          <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
            <mat-label>EMAIL</mat-label>
            <input type="text" matInput formControlName="email" placeholder="john.smith@coolcodecompany.com">
            @if (therapistForm.get('email')?.hasError('required')) {
            <mat-error>Email is <strong>required</strong></mat-error>
            }@else if (therapistForm.get('email')?.hasError('email') &&
            !therapistForm.get('email')?.hasError('required')) {
            <mat-error>Please enter a valid email address</mat-error>
            }@if (therapistForm.get('email')?.hasError('duplicate')) {
            <mat-error>A user with this email address <strong>already exists</strong></mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-12 mb-3">
          <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
            <mat-label>START TIME</mat-label>
            <input type="text" matInput formControlName="startTime" placeholder="11:00">
                        <mat-icon matSuffix matTooltip="This should be the time '11:00' the therapist starts their shift today. If ther therapist is not working today leave blank. This should be set at the start of each day." color="primary">info</mat-icon>
          </mat-form-field>
        </div>

        <div class="col-12 mb-3">
          <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
            <mat-label>END TIME</mat-label>
            <input type="text" matInput formControlName="endTime" placeholder="15:00">
            <mat-icon matSuffix matTooltip="This should be the time '15:00' the therapist finishes their shift today. If ther therapist is not working today leave blank. This should be set at the start of each day." color="primary">info</mat-icon>
          </mat-form-field>
          
        </div>

        <!-- <div class="col-12 mb-3">
          <mat-slide-toggle formControlName="working">WORKING&nbsp;<mat-icon color="primary" matTooltip="Toggle this at the start of each series of events to state whether the therapist is working that event.">info</mat-icon></mat-slide-toggle>

        </div> -->


        <div class="col-12 mb-3">
          <mat-slide-toggle formControlName="acceptBookings">ACCEPT BOOKINGS&nbsp;<mat-icon color="primary" matTooltip="Toggle this to state whether the therapist can accept bookings or not. This should be used if the therapist has a high number of bookings in their queue. Therapists can also control this themselves.">info</mat-icon></mat-slide-toggle>

        </div>
        @if (!therapistId){
        <div class="col-12 mb-3">
          <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
            <mat-label>PASSWORD</mat-label>
            <input type="password" matInput formControlName="password" placeholder="password">
            @if (therapistForm.get('password')?.hasError('required')) {
            <mat-error>Password is <strong>required</strong></mat-error>
            }
          </mat-form-field>
        </div>

        }


        <div class="col-12 mb-4">

          <div class="row">
            <div class="col-12 col-lg-5 d-flex align-items-center">
              <button [disabled]="uploadingFile" class="w-100" type="button" mat-flat-button color="accent"
                (click)="fileInput.click()">
                CHOOSE PROFILE PHOTO
              </button>
              <input hidden (change)="onFileSelected($event)" #fileInput type="file" id="file">
              <input hidden [value]="uploadedUrl" formControlName="profileLargeURL">
              @if (uploadingFile) {
              <div class="wh-button__progress-bar">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
              }

            </div>


            <div class="col-7">
              @if (uploadedUrl){
              <div>
                <img [class.reduce-opacity]="uploadingFile" style="max-width: 100px;" class="img-fluid rounded-pill"
                  [src]="uploadedUrl" />
              </div>
              }@else{
              <img style="max-width: 100px;" class="img-fluid rounded-pill reduce-opacity"
                src="https://res.cloudinary.com/coolcodecompany/image/upload/v1749476734/winning_hands/therapists/any.png" />
              }
            </div>
            @if (formSubmitted && therapistForm.get('profileLargeURL')?.hasError('required')) {
            <mat-error style="font-size: 10pt !important;">
              A profile photo is
              <strong>required</strong>
            </mat-error>
            }

          </div>


        </div>


        <div class="col-12">

          @if (therapistId){

          <div class="row">
            <div class="col-6">
              <button (click)="updateTherapist();" class="w-100" mat-flat-button color="primary">
                UPDATE
                THERAPIST
              </button>
            </div>
            <div class="col-6">
              <button mat-button color="warn" class="w-100" type="button" (click)="cancel()">
                CANCEL
              </button>
            </div>
          </div>

          }
          @else{
          <div class="row">
            <div class="col-6">
              <button [disabled]="uploadingFile" (click)="addTherapist();" class="w-100" mat-flat-button
                color="primary">
                CREATE
                THERAPIST
              </button>

            </div>
            <div class="col-6">
              <button [disabled]="uploadingFile" mat-button color="warn" class="w-100" type="button" (click)="cancel()">
                CANCEL
              </button>
            </div>
          </div>

          }

        </div>
      </div>
    </form>
  </div>
</div>
